'use client';
import { rem } from '@s7/styles';

function styles(theme) {
    var _obj, _obj1, _obj2;
    return {
        root: (_obj = {
            paddingBottom: 0
        }, _obj[theme.fn.up("sm1")] = {
            paddingBottom: rem(32)
        }, _obj),
        dropdown: (_obj1 = {
            padding: 0,
            borderRadius: rem(12)
        }, _obj1[theme.fn.up("sm1")] = {
            borderRadius: rem(24)
        }, _obj1),
        wrapper: (_obj2 = {
            position: "relative",
            height: rem(68),
            borderRadius: rem(12)
        }, _obj2[theme.fn.up("sm1")] = {
            borderRadius: rem(24)
        }, _obj2),
        input: {
            "&[data-right-section=false]": {
                paddingRight: 32
            },
            "&[data-left-section=false]": {
                paddingLeft: 32
            },
            "&::placeholder": {
                color: theme.palette.text.quaternary,
                fontSize: rem(20),
                lineHeight: rem(28),
                fontWeight: 600
            },
            fontSize: rem(20),
            lineHeight: rem(28),
            fontWeight: 600
        }
    };
}

export { styles as default };
